import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import handleAPIService from "../../hooks/handleAPIService";

export const fetchAllAdmins = createAsyncThunk(
  "allAdmin/fetchAllAdmins",
  async (_, thunkAPI) => {
    try {
      const response = await handleAPIService(
        "/usersList",
        "POST",
        {},
        () => {}
      );
      const { data, error } = response;
      if (error) throw new Error(error);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  admins: [],
  loading: false,
  error: null,
};

const allAdminSlice = createSlice({
  name: "allAdmin",
  initialState,
  reducers: {
    // Add reducers if you have other actions besides fetching
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAdmins.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllAdmins.fulfilled, (state, action) => {
        state.loading = false;
        state.admins = action.payload.data;
      })
      .addCase(fetchAllAdmins.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setAllAdmins } = allAdminSlice.actions;
export default allAdminSlice.reducer;
